import { useEffect } from "react";
import { RouterProvider } from "react-router";
import { router } from "./routes";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { getMe } from "../store/slices/authSlice";
import { Toaster } from "sonner";
export default function App() {
  const dispatch = useAppDispatch();
  const { token, initialized, loading } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (token && !initialized) {
      dispatch(getMe());
    }
  }, [dispatch, token, initialized]);

  // Listen for Service Worker postMessage to handle instant redirection when notification is clicked
  useEffect(() => {
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      const handleSwMessage = (event: MessageEvent) => {
        console.log("[App] Received Service Worker message:", event.data);
        if (event.data && event.data.type === "NAVIGATE_TO" && event.data.url) {
          const targetPath = new URL(event.data.url, window.location.origin).pathname + new URL(event.data.url, window.location.origin).search;
          if (window.location.pathname + window.location.search !== targetPath) {
            window.location.href = event.data.url;
          }
        }
      };
      navigator.serviceWorker.addEventListener("message", handleSwMessage);
      return () => {
        navigator.serviceWorker.removeEventListener("message", handleSwMessage);
      };
    }
  }, []);

  if (token && !initialized && loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-purple-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  return (
    <>
      <Toaster richColors position="top-right" />
      <RouterProvider router={router} />
    </>
  );
}
